<template>
  <div
    v-if="modalIsOpened"
    class="fixed inset-0 w-full bg-black/30"
    @click.self="closeModal"
  >
    <div
      class="fixed inset-0 overflow-y-auto flex items-start justify-center py-8"
    >
      <div class="w-[100vw] max-w-[450px] px-[20px] overflow-hidden m-auto">
        <!-- actual modal -->
        <div class="mx-auto box-effect rounded-[10px] bg-white overflow-auto">
          <div
            class="flex flex-col justify-center items-start gap-[22px] p-[20px]"
          >
            <div class="w-full h-[74px] flex flex-col items-center">
              <ResourcesIcon class="w-[50px] h-[50px] text-primary" />
              <span class="PC_Body1-SB !text-[#1F1D1F]">
                เพิ่มทรัพยากรภายในศูนย์พักพิง
              </span>
            </div>
            <div class="w-full">
              <SelectBoxComponent
                :inputId="'product_id'"
                :searchable="true"
                :allowEmpty="true"
                :keyValue="'id'"
                :keyName="'name'"
                :options="allShelterExceptionProductList"
                :value="form.product_id"
                :label="'ทรัพยากรที่ต้องการเพิ่มเข้าศูนย์'"
                :placeholder="'เลือกทรัพยากร'"
                :allData="true"
                @update:modelValue="
                  (res) => {
                    form.product = res;
                    form.product_id = res?.id || '';
                  }
                "
              />
            </div>
            <div
              v-if="form.product_id && form.product.unit_type != 1"
              class="w-full h-[1px] bg-[#DFDCDD]"
            ></div>
            <Radio
              v-if="form.product_id && form.product.unit_type != 1"
              :id="'resources_choice0'"
              v-model="form.choice"
              :name="'resources_choice0'"
              :value="0"
              :label="'ไม่ระบุจำนวน'"
            />
            <Radio
              v-if="form.product_id && form.product.unit_type != 1"
              :id="'resources_choice1'"
              v-model="form.choice"
              :name="'resources_choice1'"
              :value="1"
              :label="'ระบุจำนวนที่ต้องการ'"
              :quantitySelector="true"
              :fieldValue="form.quantity"
              @update:fieldValue="
                (val) => {
                  form.quantity = val;
                }
              "
            />
            <div class="w-full flex justify-center items-center gap-[10px]">
              <ButtonComponent
                :label="'ยกเลิก'"
                :bClass="'btn_shadow--cancel'"
                @clicked="closeModal"
              />
              <ButtonComponent
                :label="'ตกลง'"
                :bClass="'btn_shadow--save'"
                :disabled="!form.product_id"
                @clicked="save"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
    
<script setup>
import { ref, watch } from "vue";
import { useProductStore } from "@/pinia/product";
import { storeToRefs } from "pinia";

const productStore = useProductStore();
const { allShelterExceptionProductList } = storeToRefs(productStore);
const input = {
  product: "",
  product_id: "",
  choice: 0,
  quantity: "0",
};
const form = ref({ ...input });
const modalIsOpened = ref(false);

watch(
  () => form.value.choice,
  (newVal) => {
    if (newVal == 0) {
      form.value.quantity = "0";
    }
  }
);

const openModal = () => {
  modalIsOpened.value = true;
  document.body.style.overflow = "hidden";

  form.value = {
    ...input,
  };
};

const closeModal = () => {
  modalIsOpened.value = false;
  document.body.style.overflow = "auto";
};

const emit = defineEmits(["status"]);

const save = async () => {
  await productStore
    .createShelterProduct(form.value)
    .then((response) => {
      if (response.status === 200) {
        productStore.getAllShelterExceptionProduct();
        emit("status", response.data.message, "success");
        closeModal();
      }
    })
    .catch((error) => {
      if (error.status === 400) {
        emit("status", error.response.data.message, "error");
      } else {
        console.log("error", error);
      }
    });
};

defineExpose({ openModal });
</script>
    
<style lang="scss" scoped>
</style>